import { render } from "./model_type_set_set.vue?vue&type=template&id=06164d89&scoped=true"
import script from "./model_type_set_set.vue?vue&type=script&lang=js"
export * from "./model_type_set_set.vue?vue&type=script&lang=js"

import "./model_type_set_set.vue?vue&type=style&index=0&id=06164d89&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06164d89"]])

export default __exports__